module.exports = __webpack_public_path__ + "static/media/Steady Beets.640892b2.png";